/**
 * Created by qiushaoyu on 2017/12/6.
 */
import i18n from '../locale/i18n'
import { getLang } from './userInfo'

export default {
  // 基础url前缀
  // baseURL: process.env.NODE_ENV === 'development' ? 'http://47.57.156.216' : '/',
  //设置超时时间
  timeout: 50000,
  //返回数据类型
  responseType: 'json', // default
  // 请求头信息
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    'Accept-Language': getLang(i18n.locale),
    'CMHS-User-Agent': navigator.userAgent
  },
  transformResponse: [
    // 这里提前处理返回的数据
    function (data) {
      return data
    }
  ],
  //parameter参数
  params: {}
}



// WEBPACK FOOTER //
// ./src/axios/config.js